<template>
  <div style="width: 100%;height: 315px;position:relative;z-index: 77;">
    <HomeChartBlock refId="Highcharts1" :option="option"></HomeChartBlock>
  </div>
</template>

<script>
import Highcharts from 'highcharts/highstock';
import cylinder from "highcharts/modules/cylinder";
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsDrilldown from 'highcharts/modules/drilldown';
import Highcharts3D from 'highcharts/highcharts-3d';

HighchartsMore(Highcharts)
HighchartsDrilldown(Highcharts);
Highcharts3D(Highcharts);
cylinder(Highcharts);

import HomeChartBlock from './HomeChartBlock'
export default {
  props: {
    item: {
      type: Array,
      default: []
    }
  },
  components: {
    HomeChartBlock
  },
  data() {
    return {

    }
  },
  computed: {
    option() {

      let tickAmount = 0
      for (let i = 0; i < this.item.length; i++) {
        let value = !isNaN(Number(this.item[i].value)) ? Number(this.item[i].value) : 0
        if (value >= tickAmount) {
          tickAmount = value
        }
      }

      let dataOld = {
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        },
        chart: {
          type: 'areaspline',
          marginBottom: 60,
          backgroundColor: "rgba(0, 0, 0, 0)", // 不显示背景色 
        },
        title: {
          text: '',
          enabled: false
        },
        legend: {
          enabled: false,
        },
        tooltip: {
          shared: true,
          valueSuffix: '',
          backgroundColor: {
            linearGradient: [0, 0, 0, 60],
            stops: [
              [0, '#17317F'],
              [1, '#17317F']
            ]
          },
          borderWidth: 1,
          borderColor: '#00D361',
          shadow: true,
          padding: 10,
          formatter: function (data) {
            let str =
              '<div style="width: 100%;display: block;">'
              + '<div style="width: 100%;display: block;font-size: 11px;color: #00D361;font-weight: 400;">' + this.x + '票数</div>'
              + '</br>'
              + '<div style="width: 100%;display: block;font-size: 27px;color: #00D361;font-weight: bold;">' + this.y + '</div>'
              + '</div>'
            return str
          }
        },
        //4.设置滚动条可用
        scrollbar: {
          enabled: true,
          minWidth: 0,
          margin: 0,
          barBackgroundColor: 'rgba(23, 139, 226, 0.5)',
          showFull: false,//当滚动的内容被完全缩小时，是显示还是隐藏滚动条。
        },
        xAxis: {
          categories: Array.isArray(this.item) ? this.item.map((item, index) => {
            return item.name
          }) : [],
          labels: {
            style: {
              color: "#fff",
              fontSize: 11
            },
          },
          gridLineColor: "#17317F",
          lineColor: "#17317F",
        },
        yAxis: {
          title: {
            text: ''
          },
          gridLineColor: "#17317F",
          tickAmount: tickAmount > 0 ? undefined : 5,
          labels: {
            style: {
              color: '#ffffff'
            }
          }
        },
        plotOptions: {
          areaspline: {
            fillOpacity: 0.5
          },

          area: {
            fillColor: {
              linearGradient: {
                x1: 0,
                y1: 0,
                x2: 0,
                y2: 1
              },
              stops: [
                [0, '#00D361'],
                [1, new Highcharts.Color('#00D361').setOpacity(0).get('rgba')]
              ]
            },
            marker: {
              radius: 2
            },
            lineWidth: 1,
            states: {
              hover: {
                lineWidth: 1
              }
            },
            threshold: null
          }
        },
        series: [{
          type: 'area',
          name: '票数',
          color: '#00D361',
          data: Array.isArray(this.item) ? this.item.map((item, index) => {
            return item.count
          }) : []
        }]
      }
      return dataOld
    }
  },

  created() {


  },
  mounted() {

  },
  beforeDestroy() {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.home-ticket-mian {
  width: 100%;


}
</style>
 
.schedule-rogress {
  width: 92%;
  height: 19px; 
  margin-bottom: 35px;
  display: block;


  .el-progress__text {
    font-size: 16px !important;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF !important;
    margin-left: 20px;
  }

  /*.el-progress-bar__outer {
    background: linear-gradient(0deg, rgba(0, 158, 249, 0.3), rgba(130, 235, 255, 0.3), rgba(6, 150, 233, 0.3));
  }*/

  .el-progress-bar__inner {
    background: linear-gradient(0deg, rgba(0, 158, 249, 0.7), rgba(130, 235, 255, 0.7), rgba(6, 150, 233, 0.7));
  }
}

.schedule-rogress2{
  .el-progress-bar__inner {
    background: linear-gradient(0deg, rgba(219,175,0, 0.7), rgba(255,239,130, 0.7), rgba(227,181,0, 0.7));
  }
}
</style>